import React from 'react';
import styled from 'styled-components';
import CalculatorEarnings from 'components/CalculatorEarningsComponent';
import { FlexRow } from 'styles/Layout';
import { PrimaryButton, TextStyledButton } from 'styles/Buttons';
import ModalSuccessProcess from 'modules/external_tenant/components/ModalSuccessProcessComponent';
import SuccessProcess from 'modules/external_tenant/components/SuccessProcessComponent';
import { media } from 'styles/Mixins';
import HomeOBActions from 'actions/HomeActions';
import HomieContext from 'HomieContext';
import HomeOBStore from 'stores/HomeOnBoarding';
import CancelProcess from 'modules/external_tenant/components/CancelProcessComponent';
import { get as _get } from 'lodash';

const Wrapper = styled.div`
  min-height: calc(100vh - 100px);
  background: #ffffff;
`;

const WrapperContent = styled.div`
  margin-top: 46px;
  width: 300px;
  margin: 0 auto;
  margin-bottom: 20px;
`;

const WrapperCalculateEarning = styled.div`
  margin-bottom: 40px;
`;

const Row = styled(FlexRow)`
  background-color: ${({ bgColor = '#ffffff' }) => bgColor};
  min-height: ${({ minHeight = 30 }) => minHeight}px;
  margin-bottom: ${({ marginBottom = 0 }) => marginBottom}px;
`;

const Button = styled(PrimaryButton)`
  width: 150px;
  :disabled {
    background-color: #e9e9e9;
  }
`;
const ButtonText = styled(TextStyledButton)`
  width: 150px;
  &:disabled {
    text-decoration: none;
    color: #9b9b9b;
  }
`;

const Title = styled.p`
  font-size: 26px;
  font-weight: bold;
  color: #4f5ea3;
`;

const WrapperCalculatorEarnings = styled.div`
  display: ${({ finished }) => (finished ? 'none' : 'block')};
  ${media.md`
    display: block;
  `}
`;

const WrapperSuccessProcess = styled.div`
  display: ${({ finished }) => (finished ? 'block' : 'none')};
  ${media.md`
    display: none;
  `}
`;

const WrapperModalSuccessProcess = styled.div`
  display: none;
  ${media.md`
    display: ${({ finished }) => (finished ? 'block' : 'none')};
  `}
`;
type PropsTypes = {
  history?: {
    push: string => void
  },
  match: any
};
type StateTypes = {
  extra_services_amount: number,
  price: number,
  _step: string,
  id_home: string,
  enableEndButton: boolean,
  home: any,
  showModal: boolean,
  showModalCancelProcess: boolean
};

class CalculateEarningsHome extends React.Component<PropsTypes, StateTypes> {
  state = {
    showModal: false,
    showModalCancelProcess: false,
    wasFinished: false,
    enableEndButton: false,
    home: null
  };

  componentWillMount() {
    HomeOBStore.addChangeListener(this.setHomeOnBoarding);
    const home_id = this.props.match.params.home_id;
    HomeOBActions.getHomeByIdWithOnBoarding(home_id);
  }

  componentWillUnmount() {
    HomeOBStore.removeChangeListener(this.setHomeOnBoarding);
  }

  setHomeOnBoarding = (): void => {
    const home = HomeOBStore.getHome();
    this.setState({
      home
    });
  };

  setShowModal = (status: boolean): void => {
    this.setState({
      showModal: status
    });
  };

  setShowModalCancelProcess = (status: boolean): void => {
    this.setState({
      showModalCancelProcess: status
    });
  };

  setFinished = (status: boolean) => {
    this.setState({
      wasFinished: status
    });
  };

  onClickCancelButton = () => {
    this.setShowModalCancelProcess(true);
  };

  onClickFinishButton = () => {
    this.updateOnBoarding();
  };

  redirect = () => {
    const { homeApplicationId } = this.props.match.params;
    this.props.history.push(
      `/inquilinos-externos/aplicaciones/${homeApplicationId}/invitacion`
    );
  };

  redirectIndex = () => {
    this.props.history.push(`/inquilinos-externos`);
  };

  updateOnBoarding = () => {
    let { id_home, price, extra_services_amount, _step } = this.state;
    this.context.showLoadingProcessView('Guardando datos');
    let homeDataPrice = {
      home: {
        id: id_home,
        price,
        extra_services_amount,
        _step
      }
    };
    HomeOBActions.updateHomeOB(id_home, homeDataPrice, () => {
      this.context.hideLoadingProcessView();
      this.setShowModal(true);
      this.setFinished(true);
    });
  };

  handleCalculate = (canEnableButton, price, extra_services_amount) => {
    this.setState({
      extra_services_amount,
      price,
      _step: 'external_owner_info_price',
      id_home: this.props.match.params.home_id,
      enableEndButton: canEnableButton
    });
  };

  renderCalculatorEarnings() {
    let { enableEndButton, home } = this.state;
    let recommendedPrice = home ? home.externalHomePrice : 0;
    let disabled = this.wasCalculatedHome();
    return (
      <WrapperCalculatorEarnings finished={this.state.wasFinished}>
        <Row
          bgColor="#FAFAFA"
          marginBottom={46}
          minHeight={80}
          alignItems="center"
          justifyContent="center"
        >
          <Title>Inmueble</Title>
        </Row>
        <WrapperContent>
          <WrapperCalculateEarning>
            <CalculatorEarnings
              firstFee={0}
              monthlyFee={0}
              price={0}
              extraServicesAmount={0}
              minimalRentMonths={0}
              depositMonthsWarranty={0}
              recommendedPrice={recommendedPrice}
              handleCalculate={this.handleCalculate}
              disabled={disabled}
            />
          </WrapperCalculateEarning>
          <Row alignItems="center" justifyContent="space-around">
            <ButtonText disabled={disabled} onClick={this.onClickCancelButton}>
              Cancelar
            </ButtonText>
            <Button
              disabled={!enableEndButton}
              onClick={this.onClickFinishButton}
            >
              Finalizar
            </Button>
          </Row>
        </WrapperContent>
      </WrapperCalculatorEarnings>
    );
  }

  renderSuccessProccess = () => {
    return (
      <WrapperSuccessProcess finished={this.state.wasFinished}>
        <SuccessProcess
          title="¡Listo!"
          message="Pronto el equipo de Homie se contactará contigo para resolver cualquier duda que tengas."
          handleClose={this.redirect}
        />
      </WrapperSuccessProcess>
    );
  };

  renderModalSuccessProcess = () => {
    return (
      <WrapperModalSuccessProcess finished={this.state.wasFinished}>
        <ModalSuccessProcess
          show={this.state.showModal}
          message="Pronto el equipo de Homie se contactará contigo para resolver cualquier duda que tengas."
          autoClose={true}
          timerClose={5000}
          handleCloseModal={() => {
            this.setShowModal(false);
            this.setFinished(true);
            this.redirect();
          }}
        />
      </WrapperModalSuccessProcess>
    );
  };

  onClickButtonCancel = () => {
    const { currentUser } = this.context;
    HomeOBActions.deleteHomeOB(currentUser.id, this.state.home.id, () => {
      this.redirectIndex();
    });
  };

  wasCalculatedHome = () => {
    let status = _get(this.state, 'home.status');
    return !(status === 'in_progress');
  };

  render() {
    return (
      <Wrapper>
        {this.renderCalculatorEarnings()}
        {this.renderSuccessProccess()}
        {this.renderModalSuccessProcess()}

        <CancelProcess
          show={this.state.showModalCancelProcess}
          title="Estás a punto de cancelar el proceso, no se guardarán los datos que has ingresado hasta el momento."
          message="Quiero seguir con la aplicación"
          handleCloseModal={() => this.setShowModalCancelProcess(false)}
          onClickButtonCancel={this.onClickButtonCancel}
        />
      </Wrapper>
    );
  }
}

CalculateEarningsHome.contextType = HomieContext;
export default CalculateEarningsHome;
